import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    WritableSignal,
} from '@angular/core';

import { FieldInterventionService } from '@connect-services/client/services/field-intervention.service';
import { FieldInterventionEntity, FieldInterventionForm, Person } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

export type ItemWithState = {
    item: Person | FieldInterventionForm;
    updated: boolean;
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-field-intervention-entity-items-list',
    templateUrl: './field-intervention-entity-items-list.component.html',
})
export class FieldInterventionEntityItemsListComponent {
    public readonly entity: InputSignal<FieldInterventionEntity | undefined> = input<
        FieldInterventionEntity | undefined
    >();
    public readonly items: InputSignal<ItemWithState[]> = input.required();
    public readonly title: InputSignal<string> = input.required();

    protected readonly fieldInterventionService = inject(FieldInterventionService);
    protected readonly showAll: WritableSignal<boolean> = signal(false);

    public constructor() {
        effect(() => {
            this.showAll.set(!!this.items().find((item: ItemWithState): boolean => item.updated));
        });
    }

    public getLabel(item: Person | FieldInterventionForm): string {
        if ('name' in item) {
            return item.name;
        }

        return `${item.givenName} ${item.familyName}`;
    }

    public toggleList(): void {
        this.showAll.set(!this.showAll());
    }
}
